import { dashboardRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";

const permission = "all";

const isMobile = import.meta.env.VITE_MOBILE === "true";

const dashboardRouteMetadata: IRouteMetadataObj<typeof dashboardRoutesObj> = {
  home: {
    title: isMobile ? "studentDashboard.title" : "dashboard.title",
    description: isMobile
      ? "studentDashboard.description"
      : "dashboard.description",
    lazy: () => import("@/pages/dashboard/page"),
    mode: "index",
    type: "main",
    icon: "LayoutGridLine",
    breadcrumbs: [],
    permission,
    noUser: true,
  },
};

export const dashboardRoutes = createRoute<typeof dashboardRoutesObj>(
  dashboardRoutesObj,
  dashboardRouteMetadata,
);
